module.exports = __webpack_public_path__ + "img/standard-definition.0763bf6d.svg";